import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { PropertyData } from '../models/Property';
import { CardComponent } from './Card';

interface props {
    data: PropertyData[];
    propertyUseCase?: PropertyUseCaseInterface;
}

export const ListProperty = ({ data, propertyUseCase }: props) => {
    const navigate = useNavigate();
    const onClick = (id: number) => {
        navigate(`/app/${PRIVATE_ROUTES.SUB.CU_009_01}/${id}`);
    };
    return (
        <div style={{ width: '100%' }}>
            <div className="grid-container">
                {data.map((element: PropertyData, index: number) => (
                    <CardComponent
                        key={index}
                        data={element}
                        propertyUseCase={propertyUseCase}
                        onClick={() => onClick(element.id)}
                    />
                ))}
            </div>
        </div>
    );
};
